import * as React from 'react';
import Helmet from 'react-helmet';

import { withIntl, IntlProps, Language } from 'ha/i18n';
import { Titles } from '../constants';

export const HomeHelmet: React.SFC<IntlProps> = ({
  intl: { urlResolver, lang },
}) => (
  <Helmet>
    <title>{Titles[lang] || Titles.en}</title>
    <link rel="canonical" href={urlResolver.absolutizePath('/', { lang })} />
    <link
      rel="alternate"
      hrefLang="x-default"
      href={urlResolver.absolutizePath('/', { skipAddLanguage: true })}
    />
    {Object.keys(Language).map((_lang: Language) => (
      <link
        key={_lang}
        rel="alternate"
        hrefLang={_lang}
        href={urlResolver.absolutizePath('/', { lang: _lang })}
      />
    ))}
  </Helmet>
);

export default withIntl(HomeHelmet);
